import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Clock, Phone, MessageCircle, Truck, Loader2, Send } from 'lucide-react';
import Copyright from '../../components/Copyright';

const Info = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const res = await axios.get('/api/delivery-settings');
        setInfo(res.data);
      } catch (e) {
        console.error("Info fetch error:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, []);

  if (loading) return (
    <div className="min-h-screen bg-tg-bg flex items-center justify-center">
        <Loader2 className="animate-spin text-tg-hint" />
    </div>
  );

  if (!info) return null;

  // Очистка телефона для ссылки (оставляем только цифры и +)
  const phoneRaw = info.contact?.phone || "";
  const phoneClean = phoneRaw.replace(/[^\d+]/g, '');

  return (
    <div className="min-h-screen bg-tg-bg text-tg-text pb-20">
      {/* Header */}
      <div className="px-4 pb-4 pt-tg flex items-center sticky top-0 bg-tg-bg/95 backdrop-blur-md z-10 border-b border-gray-100/5">
        <button onClick={() => navigate('/profile')} className="mr-3 text-tg-text p-1 active:opacity-60">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-xl font-bold">О нас</h1>
      </div>

      <div className="p-4 space-y-6">
        
        {/* [RESTORED] Красивый градиентный заголовок */}
        <div className="w-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-8 text-center shadow-lg text-white mb-2 relative overflow-hidden">
            {/* Декоративный блик */}
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl"></div>
            
            <h2 className="text-3xl font-extrabold mb-2 tracking-tight drop-shadow-md relative z-10">
                {info.business_name}
            </h2>
            <p className="text-blue-100 text-sm font-medium opacity-90 leading-relaxed relative z-10">
                {info.description || "Вкусная еда с быстрой доставкой"}
            </p>
        </div>

        {/* Блок 1: Доставка */}
        <div className="bg-tg-secondary-bg p-4 rounded-2xl flex items-start gap-4">
            <div className="bg-blue-500/10 p-3 rounded-xl text-blue-500 shrink-0">
                <Truck size={24} />
            </div>
            <div>
                <h3 className="font-bold text-lg mb-1">Доставка</h3>
                <p className="text-tg-hint text-sm">
                    {info.pickup?.address === "Только доставка" 
                        ? "Бесплатно по Саратову и Энгельсу" 
                        : (info.pickup?.address || "Работаем на доставку")}
                </p>
            </div>
        </div>

        {/* Блок 2: Время работы */}
        <div className="bg-tg-secondary-bg p-4 rounded-2xl flex items-start gap-4">
            <div className="bg-orange-500/10 p-3 rounded-xl text-orange-500 shrink-0">
                <Clock size={24} />
            </div>
            <div>
                <h3 className="font-bold text-lg mb-1">Режим работы</h3>
                <p className="text-tg-hint text-sm">
                    {info.contact?.work_hours || "Ежедневно: 10:00 – 21:00"}
                </p>
            </div>
        </div>

        {/* Блок 3: Контакты */}
        <div className="space-y-3">
            <h3 className="font-bold text-lg px-2">Связаться с нами</h3>
            
            {/* [FIX] Телефон теперь звонит (href="tel:...") */}
            {info.contact?.phone && (
                <a href={`tel:${phoneClean}`} className="bg-tg-secondary-bg p-4 rounded-2xl flex items-center gap-4 active:scale-95 transition-transform">
                    <div className="bg-green-500/10 p-3 rounded-xl text-green-500">
                        <Phone size={24} />
                    </div>
                    <span className="font-medium text-lg">{info.contact.phone}</span>
                </a>
            )}

            {info.contact?.telegram_channel && (
                <a href={info.contact.telegram_channel} target="_blank" rel="noreferrer" className="bg-tg-secondary-bg p-4 rounded-2xl flex items-center gap-4 active:scale-95 transition-transform">
                    <div className="bg-blue-400/10 p-3 rounded-xl text-blue-400">
                        <Send size={24} />
                    </div>
                    <div className="flex flex-col">
                        <span className="font-medium">Наш Telegram</span>
                        <span className="text-xs text-tg-hint">Новости и акции</span>
                    </div>
                </a>
            )}

             {info.contact?.support && (
                <a href={info.contact.support} target="_blank" rel="noreferrer" className="bg-tg-secondary-bg p-4 rounded-2xl flex items-center gap-4 active:scale-95 transition-transform">
                    <div className="bg-purple-400/10 p-3 rounded-xl text-purple-400">
                        <MessageCircle size={24} />
                    </div>
                    <div className="flex flex-col">
                        <span className="font-medium">Поддержка</span>
                        <span className="text-xs text-tg-hint">Вопросы по заказу</span>
                    </div>
                </a>
            )}
        </div>

        <Copyright />
      </div>
    </div>
  );
};

export default Info;
